import { LucideIcon } from 'lucide-react';

// Muted on purpose: colour on this page means state (the green and red icons
// of the dependencies and scheduled jobs headers), these only name the panel.
export const PanelTitle = ({
  icon: Icon,
  title,
}: {
  icon: LucideIcon;
  title: string;
}) => (
  <h2 className="flex items-center gap-2 text-sm font-medium">
    <Icon className="size-4 text-muted-foreground shrink-0" />
    {title}
  </h2>
);
